/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import url from "../../../../Component/server";
import { Icon } from "../../../../Component/style/common_style";
import moment from "moment";
import api from "../../../../Component/axios_Interceptor/api";

interface Notice_Modal_Props {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  seq: number;
}

type data_type = {
  seq: number;
  live_seq: number;
  type: string;
  title: string;
  content: string;
  crt_dt: string;
}[];

const Notice_Modal = (props: Notice_Modal_Props) => {
  const { visible, handleModal } = props;

  const get_live_notice = () => {
    api
      .get(url.Communication_url.get_live_notice, {
        params: {
          seq: props.seq,
          type: "rn",
        },
      })
      .then(function (response) {
        set_Data(response.data);
      })
      .catch(function (error) {});
  };

  useEffect(() => {
    if (visible) {
      handleModal(true);
      get_live_notice();
    } else {
      setTimeout(() => {
        handleModal(false);
      }, 500);
    }
  }, [visible]);

  const closeModal = () => {
    handleModal(false);
  };

  const [data, set_Data] = useState<data_type>([]);

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no">
      <ModalBox $isOpen={visible} onClick={(e) => e.stopPropagation()}>
        <Title_Box>
          <div>공지사항</div>
          <Exit_Btn
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title_Box>
        <Content_Box>
          {data.length > 0 ? (
            data.map((item, index) => {
              return (
                <Notice_Box key={index}>
                  <div className="title">{item.title}</div>
                  <br />
                  <div style={{ whiteSpace: "pre-wrap" }}>{item.content}</div>
                  <br />
                  <div className="date">
                    {moment(item.crt_dt).format("YYYY.MM.DD hh:mm:ss")}
                  </div>
                </Notice_Box>
              );
            })
          ) : (
            <Empty_Box>공지가 없습니다</Empty_Box>
          )}
          <br />
          <br />
          <br />
          <br />
        </Content_Box>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Notice_Modal;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: absolute;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;

const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  max-height: 95%;
  background-color: white;
  color: #454545;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  color: #1d1d1d;
  overflow: auto;
  scrollbar-width: thin;
`;

const Title_Box = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #f0f0f0;
`;

const Exit_Btn = styled(Icon)`
  position: absolute;
  right: 30px;
  justify-self: flex-end;
  cursor: pointer;
`;

const Content_Box = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 16px;
`;

const Notice_Box = styled.div`
  width: 100%;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #f0f0f0;
  padding: 30px 0px;
  line-height: 16px;
  div.title {
    font-family: var(--font-Pretendard-SemiBold);
  }
  div.date {
    line-height: 10px;
    font-size: 14px;
    color: #8e8e8e;
  }
`;

const Empty_Box = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  box-sizing: border-box;
`;
